// Quiz data for Mistika

export const quizSteps = [
  {
    id: 1,
    type: 'options',
    title: '¿Has realizado algún tratamiento estético corporal antes?',
    subtitle: 'Esto nos permite personalizar tu plan desde cero o potenciar tus resultados anteriores.',
    field: 'tratamiento_previo',
    options: [
      { value: 'satisfecha', label: 'Sí, y estoy satisfecha/o con mis resultados', desc: 'Quiero mantener y seguir mejorando lo logrado.' },
      { value: 'no_resultados', label: 'Sí, pero no obtuve los resultados esperados', desc: 'Quiero una propuesta diferente que sí funcione.' },
      { value: 'primera_vez', label: 'No, sería mi primer tratamiento', desc: 'Estoy lista/o para empezar desde el principio.' },
    ],
    urg: { icon: 'users', html: 'Más de <strong>15.000 pacientes</strong> han transformado su cuerpo con nuestros protocolos. Tu valoración es <strong>completamente gratuita</strong>.' },
  },
  {
    id: 2,
    type: 'options',
    title: '¿Qué zona quisieras transformar primero?',
    subtitle: 'Selecciona la que más te preocupa. Después diseñaremos un plan integral para ti.',
    field: 'zona',
    options: [
      { value: 'abdomen', label: 'Abdomen' },
      { value: 'abdomen_espalda', label: 'Abdomen y espalda' },
      { value: 'piernas', label: 'Anticelulítico piernas' },
      { value: 'gluteo', label: 'Levantamiento y aumento glúteo' },
      { value: 'corporal_completo', label: 'Definición corporal completa' },
    ],
  },
  {
    id: 3,
    type: 'sliders',
    title: 'Cuéntanos un poco más sobre ti',
    subtitle: 'Esta información es confidencial y solo se usa para personalizar tu plan de tratamiento.',
    field: 'datos',
    sliders: [
      { key: 'edad', label: 'Edad', min: 18, max: 70, def: 32, unit: 'años' },
      { key: 'peso', label: 'Peso', min: 40, max: 130, def: 65, unit: 'kg' },
      { key: 'talla', label: 'Estatura', min: 140, max: 200, def: 163, unit: 'cm' },
    ],
    hint: 'Tus datos son 100% privados. Solo los usa nuestro equipo para preparar tu valoración personalizada.',
  },
  {
    id: 4,
    type: 'options',
    title: '¿Cuánto tiempo podrías dedicar a tu tratamiento?',
    subtitle: 'La frecuencia define qué tan rápido verás resultados. Tú eliges el ritmo.',
    field: 'frecuencia',
    options: [
      { value: '1x_semana', label: '2 horas · 1 vez por semana', desc: 'Resultados visibles en 10–12 semanas. Ideal para agendas ocupadas.' },
      { value: '2x_semana', label: '2 horas · 2 veces por semana ⭐', desc: 'Resultados acelerados en 6–8 semanas. La opción más popular.' },
      { value: '3x_semana', label: '2 horas · 3 veces por semana', desc: 'Resultados intensivos en 4–5 semanas. Máxima transformación.' },
    ],
  },
  {
    id: 5,
    type: 'options',
    title: 'Si el tratamiento cumple tus expectativas, ¿cuánto estarías dispuesta/o a invertir?',
    subtitle: 'Esto nos ayuda a presentarte el plan más adecuado, sin sorpresas.',
    field: 'inversion',
    options: [
      { value: '300k', label: 'Hasta $300.000' },
      { value: '500k', label: 'Hasta $500.000' },
      { value: '1m', label: 'Más de $1.000.000' },
      { value: 'a_valorar', label: 'Quiero que me valoren según mi objetivo' },
    ],
    urg: { icon: 'calendar', html: '<strong>Solo quedan 5 cupos</strong> para valoraciones gratuitas esta semana. Asegura el tuyo ahora.' },
  },
  {
    id: 6,
    type: 'insight',
    title: 'Lo que separa los resultados extraordinarios de los ordinarios',
    subtitle: 'Tenemos un dato que transforma la forma en que nuestras pacientes ven sus resultados.',
    field: '_skip_6',
    intro: 'El <strong>80%</strong> de estos resultados se deben a una valoración técnica personalizada y a la sinergia de nuestras tecnologías.',
    technologies: [
      { name: 'Ice Sculpt Criolipólisis', desc: 'Elimina grasa localizada con frío controlado. Sin cirugía, sin succión, sin dolor.', icon: '❄️' },
      { name: 'Tensamax', desc: 'Diatermia profunda que llega hasta la grasa visceral.', icon: '🔥' },
      { name: 'Body Sculptor', desc: '+20.000 contracciones por sesión. Músculo, definición y menos grasa.', icon: '💪' },
      { name: 'Infrared', desc: 'Ondas infrarrojas que aceleran el metabolismo celular.', icon: '☀️' },
      { name: 'Bioestimulación CO₂', desc: 'Activa colágeno y elastina de forma natural.', icon: '✨' },
    ],
    body: 'Cuando el protocolo no está diseñado para tu cuerpo, pierdes tiempo, dinero y motivación. Una valoración correcta es la diferencia entre cambios reales en pocas semanas o no ver ninguno.',
    pills: ['Valoración técnica', 'Plan personalizado', 'Resultados medibles'],
    ctaLabel: 'Conocer Mi Protocolo Personalizado →',
  },
  {
    id: 7,
    type: 'testimonial',
    title: 'Resultados reales de nuestras pacientes',
    subtitle: 'Casos documentados en nuestra clínica. Más de 15.000 transformaciones.',
    field: '_skip_7',
    testimonials: [
      { ini: 'AP', name: 'Andrea P.', text: 'Llevaba años intentando reducir el abdomen. En 6 sesiones vi resultados que no logré en 3 años de ejercicio solo. Increíble.' },
      { ini: 'ML', name: 'María L.', text: 'El tratamiento anticelulítico cambió mis piernas completamente. Profesionales, amables y con resultados reales.' },
      { ini: 'CG', name: 'Carolina G.', text: 'La valoración duró 45 minutos y en la tercera sesión ya notaba la diferencia. El protocolo era completamente personalizado.' },
    ],
    stats: [
      { v: '15.000+', l: 'pacientes' },
      { v: '4.9 ★', l: 'satisfacción' },
      { v: '6–8 sem', l: 'resultados visibles' },
    ],
    ctaLabel: 'Quiero resultados así →',
  },
  {
    id: 8,
    type: 'booking',
    title: 'Tu protocolo personalizado ya está listo',
    subtitle: 'Con cambios reales desde la primera semana.',
    field: '_booking',
  },
];
